import React, { Component } from 'react'
import { Button } from '@driftt/tide'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as selectors from 'modules/settings/selectors'
import * as actions from 'modules/settings/actions'

import './style.css'

const domainTail = '.drift.help'

class SettingsPageFooter extends Component {
  
  handleSaveClick = () => {
    if (!this.props.settings.driftHelpDomain.endsWith(domainTail)) {
      this.props.appendToDomain(domainTail)
    }
    
    this.props.updateSettings()
  }
  
  render() {
    const { settings, changed, updateSettingsLoading } = this.props
    return (
      <footer className="settings-page-footer">
        <Button
          type="primary"
          disabled={!changed || !settings.driftHelpDomain}
          loading={updateSettingsLoading}
          onClick={this.handleSaveClick}
        >
          Save Changes
        </Button>
        {updateSettingsLoading && <span className="settings-form-loading-text"> Hang tight! These updates might take a couple minutes. <span aria-label="High five emoji" role="img">🙏🏽</span></span>}
      </footer>
    )
  }
}

const mapStateToProps = state => ({
  settings: selectors.getSettings(state),
  changed: selectors.getChanged(state),
  updateSettingsLoading: selectors.getUpdateSettingsLoading(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    appendToDomain: actions.appendToDomain,
    updateSettings: actions.updateSettings
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPageFooter)